import useSWR from "swr";

import { fetcher } from "@aprosoja/api";
import { GetNewsData, NewsType } from "@aprosoja/types";
import { useMemo } from "react";

const useCompleteNews = (slug: string) => {
  const { data: completeNews, isLoading: completeNewsIsLoading } = slug
    ? useSWR<NewsType>(`/news/findBySlug/${slug}`, fetcher, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
      })
    : { data: undefined, isLoading: false };

  const { data: relatedNews, isLoading: relatedNewsIsLoading } =
    useSWR<GetNewsData>(
      completeNews?.category.id
        ? `/news?status=true&categoryId=${completeNews?.category.id}&limit=4`
        : null,
      fetcher,
      {
        revalidateOnMount: true,
        revalidateOnFocus: false,
      }
    );

  const { data: recentNews, isLoading: recentNewsIsLoading } =
    useSWR<GetNewsData>(`/news?limit=4`, fetcher, {
      revalidateOnMount: true,
      revalidateOnFocus: false,
    });

  const newsList = useMemo(() => {
    if (recentNews?.data?.length) {
      return recentNews.data;
    }
    return relatedNews?.data;
  }, [recentNews, relatedNews]);

  const newsListIsLoading = useMemo(() => {
    if (recentNewsIsLoading) {
      return recentNewsIsLoading;
    }
    return relatedNewsIsLoading;
  }, [recentNewsIsLoading, relatedNewsIsLoading]);

  return { completeNews, completeNewsIsLoading, newsList, newsListIsLoading };
};

export default useCompleteNews;
